/**
 * Safe localStorage utilities with error handling
 * Prevents application crashes from corrupted or malformed localStorage data
 */

/**
 * Safely parses JSON from localStorage with error handling
 * @param {string} key - The localStorage key to retrieve
 * @param {*} defaultValue - The default value to return if parsing fails
 * @returns {*} The parsed value or defaultValue if parsing fails
 */
export function safeGetJSON(key, defaultValue) {
  try {
    const saved = localStorage.getItem(key);
    if (saved === null) {
      return defaultValue;
    }
    return JSON.parse(saved);
  } catch (error) {
    console.warn(`Failed to parse localStorage key "${key}":`, error.message);
    return defaultValue;
  }
}

/**
 * Safely stores JSON in localStorage with error handling
 * @param {string} key - The localStorage key to set
 * @param {*} value - The value to stringify and store
 * @returns {boolean} True if successful, false otherwise
 */
export function safeSetJSON(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.warn(`Failed to set localStorage key "${key}":`, error.message);
    return false;
  }
}
